import {useCallback, useState} from 'react'
import {EditModeButtons} from '../../../calendar/components/EditModeButtons.tsx'
import {useConnections} from '../../../../providers/connections/useConnections.ts'
import type {AddConnectionRequest} from '@app/api-resolver/router'
import {FormFields} from './FormFields.tsx'
import {FormValues} from './FormValues.ts'
import {useForm} from '@mantine/form'
import {zod4Resolver} from 'mantine-form-zod-resolver'

type Props = {
  onSuccess: () => void
  disabled: boolean
}

export const AddForm = ({onSuccess, disabled: containerDisabled}: Props) => {
  const {addConnection} = useConnections()
  const [adding, setAdding] = useState<boolean>(false)
  const form = useForm<FormValues>({
    initialValues: {
      name: '',
      url: '',
      projectId: null,
    } satisfies FormValues,
    validate: zod4Resolver(FormValues),
  })

  const handleSubmit = useCallback(
    async (formValues: FormValues) => {
      setAdding(true)
      await addConnection({type: 'ical-subscription', ...formValues} satisfies AddConnectionRequest).finally(() =>
        setAdding(false),
      )
      onSuccess()
    },
    [addConnection, onSuccess],
  )

  const disabled = containerDisabled

  return (
    <form onSubmit={form.onSubmit(handleSubmit)} style={{display: 'flex', flexDirection: 'column', gap: 10}}>
      <FormFields form={form} disabled={disabled} />
      <EditModeButtons submitVariant={'add'} submitting={adding} disabled={disabled} />
    </form>
  )
}
